// extracted by mini-css-extract-plugin
export default {"cls1":"ImpactNavButton-cls1___d5273509e33f69e256d","cls2":"ImpactNavButton-cls2___bf4171ad5c3a542b96d ImpactNavButton-cls1___d5273509e33f69e256d"};